// ── Read operations ──────────────────────────────────────────────────────────
export const GET_DOCUMENT_VERSIONS = 'GET_DOCUMENT_VERSIONS';
export const GET_DOCUMENT_VERSIONS_SUCCESS = 'GET_DOCUMENT_VERSIONS_SUCCESS';

export const GET_DRAFT_STATE = 'GET_DRAFT_STATE';
export const GET_DRAFT_STATE_SUCCESS = 'GET_DRAFT_STATE_SUCCESS';

export const GET_DOCUMENT_VERSION_DETAIL = 'GET_DOCUMENT_VERSION_DETAIL';
export const GET_DOCUMENT_VERSION_DETAIL_SUCCESS = 'GET_DOCUMENT_VERSION_DETAIL_SUCCESS';

export const RECONSTRUCT_DOCUMENT_VERSION = 'RECONSTRUCT_DOCUMENT_VERSION';
export const RECONSTRUCT_DOCUMENT_VERSION_SUCCESS = 'RECONSTRUCT_DOCUMENT_VERSION_SUCCESS';

// ── Write operations ─────────────────────────────────────────────────────────
export const CAPTURE_DOCUMENT_CHANGES = 'CAPTURE_DOCUMENT_CHANGES';

export const DISCARD_DOCUMENT_DRAFT = 'DISCARD_DOCUMENT_DRAFT';
export const DISCARD_DOCUMENT_DRAFT_SUCCESS = 'DISCARD_DOCUMENT_DRAFT_SUCCESS';

export const RESTORE_DOCUMENT_VERSION = 'RESTORE_DOCUMENT_VERSION';
export const RESTORE_DOCUMENT_VERSION_SUCCESS = 'RESTORE_DOCUMENT_VERSION_SUCCESS';

// ── Local state management ───────────────────────────────────────────────────
export const RESET_DOCUMENT_VERSIONS = 'RESET_DOCUMENT_VERSIONS';
